import store_laboratoire from '@/store/mods/analyses/laboratoire'
import { date_heure_zone, duree_lisible } from '@/utils/laboratoire-delais'
import CompteRenduLaboratoire from '@/components/laboratoire/compte-rendu'

// LAB-RES-001 : page « Résultats » des médecins et infirmiers — suivi du circuit des analyses,
// de la demande à la validation. Lecture seule ; la restriction d'accès fera l'objet d'un chantier dédié.
const message = (error, fallback) => error && error.response && error.response.data && typeof error.response.data.message === 'string' ? error.response.data.message : fallback

export default {
    name: 'resultats-analyses-circuit',
    components: { CompteRenduLaboratoire },
    props: [],
    data() {
        return {
            recherche: '', statut: '', date_filtre: '', statuts: [], timezone: 'UTC', source_timezone: 'UTC',
            lignes: [], page: 1, pages: 1, total: 0,
            is_loading: false, erreur: '', sequence: 0, detruit: false, minuterie: null,
            modal: false, modal_titre: 'Parcours du bon', parcours: null, is_loading_detail: false, erreur_detail: '', detail_sequence: 0,
            modal_clinique: false, clinique_selection: null,
            document_bulletin_id: 0, document_demande_id: 0, document_toggler: 0,
            bulletin_ouvert: null, lignes_detail: {}, erreurs_lignes: {}, chargement_lignes: null
        }
    },

    watch: {
        modal(ouvert) {
            if (!ouvert) this.detail_sequence++
        }
    },

    mounted() {
        this.charger()
    },

    beforeDestroy() {
        this.detruit = true
        this.sequence++
        this.detail_sequence++
        if (this.minuterie) clearTimeout(this.minuterie)
    },

    methods: {
        charger() {
            if (this.detruit) return Promise.resolve()
            const sequence = ++this.sequence
            this.is_loading = true
            this.erreur = ''
            return store_laboratoire.getResultatsSuivi({ search_item: this.recherche.trim(), date: this.date_filtre, page: this.page, available_only: 1 }).then((result) => {
                if (this.detruit || sequence !== this.sequence) return
                if (!result || !Array.isArray(result.data)) throw new Error('Réponse invalide')
                this.lignes = result.data
                this.lignes_detail = {}
                if (this.bulletin_ouvert && !this.lignes.some(ligne => ligne.bulletin_id === this.bulletin_ouvert)) this.bulletin_ouvert = null
                this.total = result.total || 0
                this.pages = Math.max(1, result.last_page || 1)
                this.statuts = Array.isArray(result.statuts) ? result.statuts : []
                this.timezone = result.timezone || 'UTC'
                this.source_timezone = result.source_timezone || 'UTC'
                this.is_loading = false
            }).catch((error) => {
                if (this.detruit || sequence !== this.sequence) return
                this.lignes = []
                this.total = 0
                this.is_loading = false
                this.erreur = message(error, 'Impossible de charger les résultats. Réessayez avec Actualiser.')
            })
        },

        // Recherche à la frappe, calmée (400 ms) pour limiter les appels
        rechercher() {
            if (this.minuterie) clearTimeout(this.minuterie)
            this.minuterie = setTimeout(() => {
                this.page = 1
                this.charger()
            }, 400)
        },

        changer_filtre() {
            this.page = 1
            return this.charger()
        },

        aller_page(page) {
            if (page >= 1 && page <= this.pages) { this.page = page; this.charger() }
        },

        async basculer_analyses(ligne) {
            const id = ligne.bulletin_id
            if (this.bulletin_ouvert === id) { this.bulletin_ouvert = null; return }
            this.bulletin_ouvert = id
            if (this.lignes_detail[id]) return
            this.chargement_lignes = id
            this.$set(this.erreurs_lignes, id, '')
            try {
                const response = await store_laboratoire.getParcoursBulletin(id)
                if (!response || response.success !== true || !response.data || !Array.isArray(response.data.lignes)) throw new Error('Réponse invalide')
                if (!this.detruit) this.$set(this.lignes_detail, id, response.data.lignes.filter(item => item.resultat && item.statut === 'valide'))
            } catch (error) {
                if (!this.detruit) this.$set(this.erreurs_lignes, id, message(error, 'Impossible de charger les analyses. Réessayez.'))
            } finally {
                if (!this.detruit) this.chargement_lignes = null
            }
        },

        reessayer_analyses(ligne) {
            this.bulletin_ouvert = null
            return this.basculer_analyses(ligne)
        },

        ouvrir_renseignement(ligne) {
            this.clinique_selection = ligne
            this.modal_clinique = true
        },

        ouvrir_document(ligne, item) {
            this.document_bulletin_id = ligne.bulletin_id
            this.document_demande_id = item.demande_id
            this.document_toggler += 1
        },

        ouvrir_detail(ligne) {
            const sequence = ++this.detail_sequence
            this.parcours = null
            this.erreur_detail = ''
            this.modal_titre = 'Parcours — ' + (ligne.reference || ('Bon n° ' + ligne.bulletin_id))
            this.modal = true
            this.is_loading_detail = true
            return store_laboratoire.getParcoursBulletin(ligne.bulletin_id).then((response) => {
                if (this.detruit || sequence !== this.detail_sequence || !this.modal) return
                if (!response || response.success !== true || !response.data) throw new Error('Réponse invalide')
                this.parcours = response.data
                this.is_loading_detail = false
            }).catch((error) => {
                if (this.detruit || sequence !== this.detail_sequence || !this.modal) return
                this.is_loading_detail = false
                this.erreur_detail = message(error, 'Impossible de charger le parcours de ce bon.')
            })
        },

        analyses_resume(ligne) {
            const analyses = Array.isArray(ligne.analyses) ? ligne.analyses : []
            if (!analyses.length) return '—'
            if (analyses.length <= 2) return analyses.join(', ')
            return analyses.slice(0, 2).join(', ') + '… +' + (analyses.length - 2)
        },

        date_heure(value) {
            const parcours = this.parcours || {}
            return date_heure_zone(value, parcours.timezone || this.timezone, parcours.source_timezone || this.source_timezone) || 'Non renseignée'
        },

        delai_lisible(ligne) {
            const heures = ligne.delai_heures !== null && ligne.delai_heures !== undefined ? ligne.delai_heures : ligne.ecoule_heures
            return heures === null || heures === undefined ? '—' : (ligne.valide_at ? '' : 'En cours · ') + heures + ' h'
        },

        minutes_lisibles(minutes) {
            return duree_lisible(minutes)
        }
    }
}
